import { AssetAllocationDTO, AssetClassEnum } from '../../../../../../api/useDefaultAssetAllocationQuery';

export const applyProductAssetAllocation = (
  assetAllocation: AssetAllocationDTO[],
  assetClasses: Partial<Record<AssetClassEnum, number>> | undefined,
  primaryAssetClass: AssetClassEnum,
): AssetAllocationDTO[] =>
  assetAllocation.map(allocation => {
    if (assetClasses != null) {
      return {
        ...allocation,
        y: assetClasses[allocation.id] ?? 0,
      };
    }

    return {
      ...allocation,
      y: allocation.id === primaryAssetClass ? 100 : 0,
    };
  });
